import { render, staticRenderFns } from "./CreateAttributeDetail.vue?vue&type=template&id=45be2581&scoped=true"
import script from "./CreateAttributeDetail.vue?vue&type=script&lang=js"
export * from "./CreateAttributeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be2581",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45be2581')) {
      api.createRecord('45be2581', component.options)
    } else {
      api.reload('45be2581', component.options)
    }
    module.hot.accept("./CreateAttributeDetail.vue?vue&type=template&id=45be2581&scoped=true", function () {
      api.rerender('45be2581', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/CreateAttributeDetail.vue"
export default component.exports